import axios from "axios";
export const axiosApiCall = axios.create({ withCredentials: true });

axiosApiCall.interceptors.request.use((config: any) => {
   console.log("isUpload", config.isUpload);
    if (config.isDownload) 
        {
        config.headers["Content-Type"] = "application/pdf";
    } 
    else if (config.isUpload) {
        // config.headers["Accept"] = "application/json, text/plain, */*";
        config.headers["Content-Type"] = "undefined";
    }
    else {        
        config.headers["Content-Type"] = "application/json; charset=utf-8";
        config.headers["Accept"] = "application/json";
    }
    return config;
})